import { render, staticRenderFns } from "./form-comp.vue?vue&type=template&id=e3074cd4"
import script from "./form-comp.vue?vue&type=script&lang=js"
export * from "./form-comp.vue?vue&type=script&lang=js"
import style0 from "./form-comp.vue?vue&type=style&index=0&id=e3074cd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports